module.exports = __webpack_public_path__ + "fonts/3954.61c0044e.ttf";